import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardAction } from '@/common/components/CardAction/CardAction';
import { Dialog } from '@/common/components/Dialog/Dialog';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { IconAgentIRS } from '@/common/containers/Dashboard/AI/AgentIcons/AgentIcons';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import { useRouter } from 'expo-router';

export type TIRSAgentCardProps = {
  onPress?: () => void;
};

export function IRSAgentCard({ onPress }: TIRSAgentCardProps) {
  const { t } = useTranslation();
  const {
    features: { ff_employee_coverflex_ai },
  } = useFeatures();
  const router = useRouter();
  const [showModal, setShowModal] = useState(false);

  const handlePress = () => {
    if (!ff_employee_coverflex_ai) {
      setShowModal(true);
      return;
    }

    router.navigate({
      pathname: ROUTES.COVERFLEX_AI,
      params: {
        agent: 'irs_agent',
      },
    });
  };

  return (
    <>
      <CardAction
        backgroundColor="accentPrimary10"
        title={t('dashboard.coverflex_ai.agents.irs_agent.title')}
        description={t('dashboard.coverflex_ai.agents.irs_agent.description')}
        illustration={{
          asset: <IconAgentIRS width={80} height={80} />,
        }}
        onPress={onPress ?? handlePress}
        action={<Icon icon="chevron-right" />}
        size="md"
      />
      {showModal && (
        <Dialog
          icon={<Icon icon="calendar" />}
          iconBadgeColor="accentSecondary20"
          onClose={() => setShowModal(false)}
          title={t('dashboard.coverflex_ai.irs_agent_dialog.title')}
          message={t('dashboard.coverflex_ai.irs_agent_dialog.description')}
          primaryAction={{
            children: t(
              'dashboard.coverflex_ai.irs_agent_dialog.confirm_label'
            ),
            onPress: () => {
              window.open(
                'https://www.coverflex.com/pt/simulador-irs-2025',
                '_blank'
              );
            },
          }}
          secondaryAction={{
            children: t('general.navigation.cancel'),
            onPress: () => setShowModal(false),
          }}
        ></Dialog>
      )}
    </>
  );
}
